import React, { useEffect } from 'react';
import { Row, Col, Input, Form } from '@duxton-web/ui';
import _ from 'lodash';

/**
 * The component is for translating the value from minutes -> days on the fly
 * as the value in backend is minute-based while the UI showing day-based
 */
const MinuteDayComponent = ({ value, onChange, style }) => {
  let internalVal = value / (24 * 60);
  const internalOnChange = (e) => {
    internalVal = e.target.value;
    onChange(internalVal * (24 * 60));
  };

  return (<Input style={style} type="number" min="1" value={internalVal} onChange={internalOnChange} />);
};

// TODO: Update UI for adapting both options (untilRelativeTime or byDuration)
// But for now only untilRelativeTime is in use
// https://wiki.grab.com/display/REW/RFC+-+Journey+builder+backend#RFCJourneybuilderbackend-Storageentity:~:text=%22type%22%3A%20%22untilRelativeTime%22%2C%20//%20either%20untilRelativeTime%20or%20byDuration
const DelayForm = (props) => {
  useEffect(() => {
  }, [props.node]);
  const isRelative = _.get(props, 'node.data.type', '') === 'untilRelativeTime';
  const formPath = isRelative ? [props.node.id, 'data', 'relativeTime', 'waitInMin'] : [props.node.id, 'data', 'duration', 'waitInMin'];
  return (
    <div className="jb-form-delay">
      <Row>
        <Col span={24}>
          <Form.Item label="Duration" name={formPath}>
            <MinuteDayComponent style={{ width: '40%' }} />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default DelayForm;
